/// <amd-module name="SuiteCommerce.GridOrder.Utils"/>
define("SuiteCommerce.GridOrder.Utils", ["require", "exports", "jQuery", "SuiteCommerce.GridOrder.Common.DependencyProvider"], function (require, exports, jQuery, DependencyProvider_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Device;
    (function (Device) {
        Device[Device["phone"] = 0] = "phone";
        Device[Device["tablet"] = 1] = "tablet";
        Device[Device["desktop"] = 2] = "desktop";
    })(Device || (Device = {}));
    var Utils = /** @class */ (function () {
        function Utils() {
        }
        Utils.isPhoneDevice = function () {
            return this.getDeviceType() === Device.phone;
        };
        Utils.isTabletDevice = function () {
            return this.getDeviceType() === Device.tablet;
        };
        Utils.getDeviceType = function (widthToCheck) {
            var width = widthToCheck || this.getViewportWidth();
            if (width < 768) {
                return Device.phone;
            }
            if (width < 992) {
                return Device.tablet;
            }
            return Device.desktop;
        };
        Utils.getViewportWidth = function () {
            return jQuery(window).width();
        };
        Utils.translate = function (text) {
            var continuationText = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                continuationText[_i - 1] = arguments[_i];
            }
            return DependencyProvider_1.UtilsModule.translate(text, continuationText);
        };
        Utils.formatCurrency = function (value, symbol) {
            return DependencyProvider_1.UtilsModule.formatCurrency(value, symbol);
        };
        return Utils;
    }());
    exports.Utils = Utils;
});
